import { useState } from 'react';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// project imports
import ChangePasswordDialog from 'features/auth/ChangePasswordDialog';

// assets
import LockOutlined from '@ant-design/icons/LockOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton onClick={() => setDialogOpen(true)}>
          <ListItemIcon>
            <LockOutlined />
          </ListItemIcon>
          <ListItemText primary="Cambiar contraseña" />
        </ListItemButton>
      </List>
      <ChangePasswordDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
}
